var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 339,
    viewBox: "0 0 205 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_15237)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.614 11.1368L58.9822 1.19499C51.3542 0.474207 43.6701 1.75939 36.6918 4.92316C15.8628 7.51054 0.415041 25.5097 1.017 46.4901L9.72322 343.458C10.2697 360.332 21.1222 375.139 37.0489 380.74L120.976 409.93C125.308 411.444 129.863 412.221 134.453 412.23C139.593 412.231 144.685 411.242 149.451 409.316C149.805 409.316 150.171 409.331 150.54 409.347C150.917 409.364 151.297 409.38 151.672 409.38C160.606 409.395 169.33 406.673 176.67 401.581C187.237 394.388 193.736 382.582 194.161 369.806L203.981 52.918C204.645 31.5703 187.79 13.2008 165.614 11.1368ZM121.44 408.551L37.5131 379.362C22.1578 373.957 11.6913 359.685 11.1516 343.416L2.44542 46.4901C2.10955 35.213 6.63879 24.3358 14.8792 16.6297C23.1197 8.92371 34.2757 5.13288 45.5051 6.22302L147.566 16.1362C168.115 18.1878 183.592 35.7596 183.033 56.4034L173.62 372.62C173.244 385.117 166.942 396.689 156.647 403.784C146.352 410.879 133.295 412.649 121.483 408.551H121.44ZM192.711 369.734L202.553 52.918C203.195 32.2774 186.911 14.5578 165.478 12.5581L58.8465 2.61626C52.9411 2.06285 46.9851 2.74138 41.3555 4.60891C42.7862 4.59828 44.2164 4.66026 45.6408 4.7946L147.716 14.715C169.014 16.8378 185.057 35.05 184.476 56.4462L175.048 372.662C174.582 387.663 165.908 401.193 152.472 407.88C160.83 407.747 168.96 405.137 175.834 400.381C186.027 393.443 192.297 382.057 192.711 369.734Z",
    fill: "url(#paint0_linear_295_15237)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.28 25.9566C160.2 27.4779 172.391 41.3621 172.042 57.5604L165.228 370.584C165.077 380.445 160.226 389.64 152.172 395.331C144.36 400.933 134.343 402.469 125.211 399.467L40.9341 372.091C28.4905 367.97 19.9761 356.477 19.6578 343.373L11.673 48.2257C11.417 39.283 15.0082 30.6599 21.5362 24.5425C27.9101 18.5955 36.5271 15.6651 45.2051 16.4934L144.28 25.9566ZM125.618 398.11C134.326 400.978 143.881 399.513 151.329 394.167H151.308C158.993 388.738 163.622 379.964 163.764 370.556L170.613 57.5033C170.949 42.0549 159.321 28.7849 144.137 27.3565L45.0694 17.8575C44.1552 17.7718 43.241 17.7289 42.3268 17.7289C34.966 17.7435 27.8851 20.5513 22.5147 25.5852C16.2847 31.4216 12.8572 39.6496 13.1014 48.1828L21.0862 343.344C21.3847 355.845 29.5059 366.811 41.3769 370.741L125.618 398.11Z",
    fill: "url(#paint1_linear_295_15237)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0369 75.4932L44.2351 110.379L75.2691 113.57L75.0709 78.6853L44.0369 75.4932ZM48.6407 105.851L48.4986 80.9329L70.6662 83.2131L70.8073 108.131L48.6407 105.851Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.511 191.288L142.195 195.164L142.167 190.18L108.916 186.76L108.888 181.777L104.455 181.321L104.511 191.288Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9604 86.3726L66.2606 87.7399L66.3457 102.692L53.0455 101.323L52.9604 86.3726Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9234 155.688L71.091 157.967L71.2322 182.885L49.0646 180.606L48.9234 155.688ZM44.6599 185.134L75.6939 188.325L75.4957 153.44L44.4617 150.248L44.6599 185.134Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.385 161.127L66.6852 162.494L66.7702 177.446L53.4701 176.078L53.385 161.127Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.309 114.97L115.141 112.691L115 87.7727L137.168 90.0519L137.309 114.97ZM110.539 82.333L110.737 117.218L141.771 120.41L141.573 85.5241L110.539 82.333Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.462 93.2119L132.762 94.5792L132.847 109.531L119.547 108.163L119.462 93.2119Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.932 124.481L141.799 125.393L141.856 135.361L132.989 134.449L132.932 124.481Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3767 135.297L53.2431 136.209L53.3002 146.176L44.4338 145.264L44.3767 135.297Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8146 120.15L73.0808 118.326L73.1088 123.309L95.2764 125.59L95.2193 115.622L95.1913 110.639L99.625 111.094L99.568 101.127L95.1352 100.671L90.7015 100.215L86.2678 99.7593L86.2117 89.7918L90.6445 90.2483L90.6735 95.2315L106.19 96.8276L106.105 81.8768L101.672 81.4204L101.728 91.3879L95.0782 90.7037L95.0211 80.7362L92.8048 80.5085L83.9383 79.5966L81.721 79.3689L81.8631 104.287L90.7295 105.199L90.7576 110.182L81.8911 109.27L81.9192 114.255L90.7866 115.167L90.8146 120.15Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2917 120.346L50.9418 121.03L50.9978 130.998L59.8653 131.91L64.299 132.366L66.5154 132.593L66.5434 137.577L57.6769 136.665L57.705 141.648L66.5724 142.56L66.6004 147.545L84.3343 149.368L84.3053 144.384L71.0051 143.016L70.9771 138.032L70.921 128.065L64.271 127.382L64.2274 119.907L59.7937 119.45L59.8363 126.925L55.4035 126.47L55.3465 116.502L44.2637 115.363L44.2917 120.346Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3709 180.182L93.3003 167.723L84.4329 166.811L84.3768 156.843L79.9431 156.388L80.0282 171.338L88.8946 172.25L88.9372 179.726L80.0707 178.814L80.0988 183.798L88.9662 184.709L88.9942 189.693L100.078 190.833L100.049 185.849L93.3989 185.165L93.3709 180.182Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.255 132.625L106.389 131.713L106.317 119.254L101.884 118.798L101.983 136.241L124.15 138.52L124.121 133.537L119.689 133.081L119.66 128.097L126.311 128.781L126.282 123.797L119.632 123.114L115.198 122.657L110.765 122.202L110.793 127.185L115.227 127.642L115.255 132.625Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.076 177.022L117.727 177.706L117.755 182.689L126.622 183.601L126.594 178.618L126.565 173.633L126.522 166.159L117.656 165.247L117.698 172.722L111.048 172.038L111.006 164.562L106.572 164.107L106.615 171.582L102.181 171.126L102.068 151.191L97.6341 150.736L97.6061 145.752L93.1724 145.296L93.0883 130.346L77.5708 128.75L77.6279 138.717L82.0606 139.172L82.0325 134.189L88.6826 134.873L88.7397 144.84L88.7957 154.807L97.6632 155.719L97.7483 170.67L97.7763 175.654L102.21 176.11L106.643 176.566L111.076 177.022Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.493 147.364L130.843 146.679L126.409 146.224L115.325 145.084L115.383 155.051L110.949 154.595L110.893 144.628L106.459 144.172L106.544 159.123L119.844 160.49L119.787 150.523L126.437 151.207L126.48 158.683L130.914 159.138L130.871 151.664L137.521 152.347L137.606 167.298L130.956 166.614L131.041 181.565L142.125 182.705L142.096 177.721L135.446 177.037L135.418 172.054L142.068 172.737L141.955 152.803L141.927 147.819L141.884 140.344L137.451 139.888L137.493 147.364Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3818 37.6963L141.572 48.4944L141.572 64.5239L43.8066 54.4931L43.3818 37.6963Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3818 207.696L141.572 218.494L141.572 315.524L43.8066 305.493L43.3818 207.696Z",
    fill: "url(#paint2_linear_295_15237)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_295_15237",
    x1: 168.613,
    y1: 375.193,
    x2: 168.613,
    y2: 107.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_295_15237",
    x1: 164.833,
    y1: 366.355,
    x2: 164.833,
    y2: 16.3219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739309,
    stopColor: "#C9C9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_295_15237",
    x1: 135.899,
    y1: 302.091,
    x2: 141.353,
    y2: 215.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_15237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 339,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileQrIcon);
export default __webpack_public_path__ + "static/media/MobileQrIcon.902b8815.svg";
export { ForwardRef as ReactComponent };